import TeamsDetailsBlock from './TeamsDetailsBlock';

export default TeamsDetailsBlock;
